import { render } from "./CreateMyAccount.vue?vue&type=template&id=4c38834a&ts=true"
import script from "./CreateMyAccount.vue?vue&type=script&lang=ts"
export * from "./CreateMyAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__